export default __webpack_public_path__ + "static/media/sub-category-kitchensAndPopUps-popUpSpace.5d8b4f9a.jpg";